module.exports = __webpack_public_path__ + "static/media/2.14c107d0.png";